import { NgModule } from '@angular/core';
import { KNZUtilModule } from '@knz/util';

@NgModule({
  imports: [KNZUtilModule],
})
export class LodopModule {}
